import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PlatformBankDetails {
  bankName: string;
  routingNumber: string;
  accountNumber: string;
  enabled: boolean;
  settlementDays: string;
}

/**
 * Hook to fetch platform bank details for Traditional ACH payments
 */
export function usePlatformBankDetails() {
  return useQuery({
    queryKey: ['platform-bank-details'],
    queryFn: async (): Promise<PlatformBankDetails> => {
      const { data, error } = await supabase
        .from('platform_settings')
        .select('setting_key, setting_value')
        .in('setting_key', [
          'platform_bank_routing_number',
          'platform_bank_account_number',
          'platform_bank_name',
          'traditional_ach_enabled',
          'traditional_ach_settlement_days'
        ]);

      if (error) throw error;

      // Transform array to object
      const settings = (data || []).reduce((acc, item) => ({
        ...acc,
        [item.setting_key]: item.setting_value
      }), {} as Record<string, string>);

      return {
        bankName: settings.platform_bank_name || '',
        routingNumber: settings.platform_bank_routing_number || '',
        accountNumber: settings.platform_bank_account_number || '',
        enabled: settings.traditional_ach_enabled === 'true',
        settlementDays: settings.traditional_ach_settlement_days || '3-5'
      };
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
